<template>
  <div class="login-form login-signin1">
    <form class="form" novalidate="novalidate" id="kt_login_signin1_form">
      <div class="pb-13 pt-lg-0 pt-5">
        <h3 class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg">
          {{ $t("login.welcome") }}
        </h3>
        <span class="text-muted font-weight-bold font-size-h4">
          {{ $t("login.access") }}
        </span>
      </div>
      <div class="form-group">
        <label class="font-size-h6 font-weight-bolder text-dark">{{$t("login.email")}}</label>
        <div id="example-input-group-1" label="" label-for="example-input-1">
          <input
            class="form-control form-control-solid h-auto py-7 px-6 rounded-lg"
            type="text"
            name="email"
            ref="email"
            v-model="form.email"
          />
        </div>
      </div>
      <div class="pb-lg-0 pb-5">
        <button
          ref="kt_login_signin1_submit"
          class="
            btn btn-primary
            font-weight-bolder font-size-h6
            px-15
            py-4
            my-3
            mr-3
          "
        >
          {{ $t("login.continue") }}
        </button>

        <div
          role="alert"
          v-bind:class="{ show: errors.length }"
          class="alert fade alert-danger"
        >
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ formatErrorMessage(error.message) }}
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import KTUtil from "@/assets/js/components/util";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import { LOGOUT_NO_REDIRECT, VERIFY_LOGIN } from "@/core/services/store/auth.module";
import Api from "@/core/services/api.service";
import Swal from "sweetalert2";

export default {
  name: "signInStep1Form",
  data() {
    return {
      form: {
        email: "",
      },
    };
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
  },
  beforeMount(){
      // ----------------------------------------------
    // Initialisation du localStorage 
    // ----------------------------------------------
    const currentLanguage = localStorage.getItem("language");
    let authErrors = localStorage.getItem('auth_errors');
    localStorage.clear();
    if (currentLanguage) {
      localStorage.setItem("language", currentLanguage);
    }
    if (authErrors) {
      try{
        authErrors = JSON.parse(authErrors);
      }finally{
        this.$store.state.auth.errors = authErrors;
      }
    }
  },
  methods: {
    formatErrorMessage(message) {
      try{
          if(Api.ERRORS_CODE.AUTHENTICATION.HANDLED_ERRORS.includes(message)){
            return this.$i18n.t(`auth.errors.${message}`);
          }
          return message;
      }
      catch(error){
        return message;
      }
    }
  },
  mounted() {
    // ----------------------------------------------
    // Gestion des événements du formulaire 
    // ----------------------------------------------
    const signin_form = KTUtil.getById("kt_login_signin1_form");
    this.fv = formValidation(signin_form, {
      fields: {
        email: {
          validators: {
            notEmpty: {
              message: this.$i18n.t("login.emailRequired"),
            },
            regexp: {
              regexp: "^([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|\"([]!#-[^-~ \t]|(\\[\t -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|[[\t -Z^-~]*])$",
              message: this.$i18n.t("login.emailRequired"),
            },
          },
        },
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap(),
      },
    });

    this.fv.on("core.form.valid", () => {
      const email = this.form.email;

      // Suppression des erreurs existantes
      this.$store.dispatch(LOGOUT_NO_REDIRECT);

      // Ajout du spinner au bouton
      const submitButton = this.$refs["kt_login_signin1_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      this.$store
        .dispatch(VERIFY_LOGIN, { email })
        // go to which page after successfully login
        .then((data) => {
          if(data && data["type"] == "oidc" && localStorage.getItem("auth_client") != undefined){
            window.location.href = `${process.env.VUE_APP_API}/login/sso?step=init&client=${localStorage.getItem("auth_client")}`; 
          }
          else if (data && data["type"] == "internal"){
            this.$emit('showForm', 'signin2');
          }
        })
        .catch((error) => console.log(error))
        .finally(() => {
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    });

    this.fv.on("core.form.invalid", () => {
      Swal.fire({
        title: "",
        text: this.$i18n.t("login.incorrectData"),
        icon: "error",
        confirmButtonClass: "btn btn-secondary",
        heightAuto: false,
      });
    });
  },
};
</script>
